class HttpTrialManager {
  _maxTrial: number
  _trialMap = new Map<string, number>()

  constructor(max: number) {
    this._maxTrial = max
  }

  isMax(httpUrl?: string) {
    if (httpUrl) {
      const trial = this._trialMap.get(httpUrl)

      if (trial) {
        return trial >= this._maxTrial
      }
    }

    return false
  }

  addTry(httpUrl?: string) {
    if (!httpUrl) return

    const trial = this._trialMap.get(httpUrl)

    this._trialMap.set(httpUrl, trial ? trial + 1 : 1)
  }

  resetTry(httpUrl?: string) {
    if (!httpUrl) return

    this._trialMap.delete(httpUrl)
  }
}

const httpTrialManager = new HttpTrialManager(10)
export default httpTrialManager
